<template>
    <div>
  
      <!-- แสดงภาพ -->
      <v-dialog v-model="showphoto" max-width="500" persistent>
        <v-card class="ma-0">
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" class="text-center">
                <img class="hidden-md-and-up" :src="showphotolink" width="300">
                <img class="hidden-sm-and-down" :src="showphotolink" width="450">
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-btn text color="#1976d2" @click="Opentap(showphotolink)">{{ use_language.newtab }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="#1976d2" @click="ClosePopup()">{{ use_language.close }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
    </div>
  </template>
  
  <script>
    import { get_languages } from "@/website/global_function";
    export default {
      props: [
        'showphotolink',
        'showphoto',
      ],
      data() {
        return {
          use_language: {},
        };
      },
      async created() {
        this.use_language = await this.get_languages(localStorage.getItem("set_language"));
      },
      methods: {
        get_languages,
        Opentap(PhotoLink){
          window.open(PhotoLink);
        },
        ClosePopup(){
          !this.showphoto
          this.$emit('emitshowphoto', false)
        },
      },
    }
  </script>
  